import { render, staticRenderFns } from "./SocialSummaryPost.vue?vue&type=template&id=b8f25cc8&"
import script from "./SocialSummaryPost.vue?vue&type=script&lang=js&"
export * from "./SocialSummaryPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8f25cc8')) {
      api.createRecord('b8f25cc8', component.options)
    } else {
      api.reload('b8f25cc8', component.options)
    }
    module.hot.accept("./SocialSummaryPost.vue?vue&type=template&id=b8f25cc8&", function () {
      api.rerender('b8f25cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSummaryPost.vue"
export default component.exports